export enum HttpStatus {
    BAD_REQUEST = 400,
}



// WEBPACK FOOTER //
// ./src/app/enums/http-status.ts